// Replacements for former inline `on*=` HTML attributes.
//
// The Content-Security-Policy no longer allows 'unsafe-inline' for scripts
// (see config/initializers/settings_for_secure_headers.rb), which disables
// inline event-handler attributes such as onclick="...". These handlers are
// re-wired here via event delegation on `document`, so they keep working and
// also cover elements that are cloned/inserted dynamically (e.g. the
// assign-to-group answer templates).
document.addEventListener("click", function (event) {
  // <a data-click-target="#hidden-file-input"> — proxy the click to the target,
  // replacing onclick="$('#hidden-file-input').click();".
  const clickProxy = event.target.closest("[data-click-target]")
  if (clickProxy) {
    event.preventDefault()
    const target = document.querySelector(clickProxy.getAttribute("data-click-target"))
    if (target) target.click()
    return
  }

  // <a data-history-back> — replaces onclick="history.back();".
  const backTrigger = event.target.closest("[data-history-back]")
  if (backTrigger) {
    event.preventDefault()
    window.history.back()
    return
  }

  // <a data-action="reload-page"> — replaces onclick="window.location.reload();".
  const reloadTrigger = event.target.closest('[data-action="reload-page"]')
  if (reloadTrigger) {
    event.preventDefault()
    window.location.reload()
    return
  }

  // <a href="#" data-void-href> — former href="javascript:void(0)" placeholder
  // links (buttons-as-anchors). Suppress the default "#" jump; any real behavior
  // is attached by other (delegated) click listeners, which still fire because
  // preventDefault does not stop propagation.
  const voidLink = event.target.closest("a[data-void-href]")
  if (voidLink) {
    event.preventDefault()
  }

  // Nested add/remove field buttons — essay, bounce, likert, multi-choice,
  // multi-choice-image, order-image, order-video, ranking, assign-to-group,
  // signings, group files, followers, form recipients, etc. These replace the
  //   onclick="add_x(this, association, fields, view[, extra]); return false;"
  //   onclick="remove_x(this);"
  // that the link_to_function_* Ruby helpers used to emit.
  //
  // The function name comes from server-rendered markup, is constrained to the
  // add_*_fields / remove_*_fields naming convention, and is then resolved
  // against `window` — this is a named-function call, never eval of a string,
  // so it does not reintroduce the injection surface CSP is meant to close.
  const addBtn = event.target.closest("[data-nested-add]")
  if (addBtn) {
    event.preventDefault()
    callNestedFieldFn(addBtn.getAttribute("data-nested-add"), [
      addBtn,
      addBtn.dataset.association,
      addBtn.dataset.fields,
      addBtn.dataset.view,
      addBtn.dataset.extra,
    ])
    return
  }

  const removeBtn = event.target.closest("[data-nested-remove]")
  if (removeBtn) {
    event.preventDefault()
    callNestedFieldFn(removeBtn.getAttribute("data-nested-remove"), [removeBtn])
  }
})

// <select|input data-submit-form-on-change> — replaces onchange="this.form.submit();"
// (and the checkbox onclick="$(this).submit();"). requestSubmit fires the submit
// event so jquery-ujs still intercepts remote (data-remote) forms; plain submit()
// would bypass it.
document.addEventListener("change", function (event) {
  const control = event.target.closest("[data-submit-form-on-change]")
  if (!control || !control.form) return
  if (control.form.requestSubmit) {
    control.form.requestSubmit()
  } else {
    control.form.submit()
  }
})

const NESTED_FIELD_FN = /^(add|remove)_[a-z0-9_]+_fields$/

function callNestedFieldFn(name, args) {
  if (!name || !NESTED_FIELD_FN.test(name)) return
  const fn = window[name]
  if (typeof fn === "function") fn(...args)
}
